import React, { ReactNode } from 'react';

import * as RadixTooltip from '@radix-ui/react-tooltip';

interface TooltipProps extends RadixTooltip.TooltipContentProps {
  readonly trigger: ReactNode;
  readonly children: ReactNode;
  readonly unwrap?: boolean;
  readonly className?: string;
  readonly defaultOpen?: RadixTooltip.TooltipProps['defaultOpen'];
  readonly open?: RadixTooltip.TooltipProps['open'];
  readonly onOpenChange?: RadixTooltip.TooltipProps['onOpenChange'];
  readonly delayDuration?: RadixTooltip.TooltipProviderProps['delayDuration'];
  readonly disableHoverableContent?: RadixTooltip.TooltipProviderProps['disableHoverableContent'];
}

function Tooltip({
  unwrap,
  trigger,
  children,
  className,
  defaultOpen,
  open,
  onOpenChange,
  delayDuration,
  disableHoverableContent,
  ...props
}: TooltipProps) {
  return (
    <RadixTooltip.Root
      open={open}
      defaultOpen={defaultOpen}
      onOpenChange={onOpenChange}
      delayDuration={delayDuration}
      disableHoverableContent={disableHoverableContent}
    >
      <RadixTooltip.Trigger asChild className={className}>
        {trigger}
      </RadixTooltip.Trigger>
      <RadixTooltip.Portal>
        {unwrap ? (
          children
        ) : (
          <RadixTooltip.Content
            align="center"
            side="bottom"
            sideOffset={5}
            {...props}
            className="z-50 rounded bg-neutral-900/70 px-4 py-2 backdrop-blur-sm"
          >
            {children}
            <RadixTooltip.Arrow className="opacity-70" />
          </RadixTooltip.Content>
        )}
      </RadixTooltip.Portal>
    </RadixTooltip.Root>
  );
}

Tooltip.Arrow = RadixTooltip.TooltipArrow;
Tooltip.Content = RadixTooltip.Content;

export { Tooltip };
